// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-open .modal {
  padding-right: 0px !important;
}

.Example__container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 0;
  padding: 10px;
}
.Example__container__load {
  margin-top: 1em;
  color: white;
}
.Example__container__document .react-pdf__Document {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Example__container__document .react-pdf__Page {
  max-width: calc(100% - 2em);
  border-radius: 8px;
  overflow: hidden;
}
@media (max-width: 1199.98px) {
  .Example__container__document .react-pdf__Page__svg {
    width: 600px !important;
    height: auto !important;
  }
}
@media (max-width: 767.98px) {
  .Example__container__document .react-pdf__Page__svg {
    width: 400px !important;
    height: auto !important;
  }
}
.Example__container__document .react-pdf__Page__svg svg {
  max-width: 100%;
  height: auto !important;
}
.Example__container__document .react-pdf__message {
  padding: 20px;
  color: #ff9900;
}
.Example__container__document:hover .page-controls {
  opacity: 1;
}
.Example__container__document .page-controls {
  position: absolute;
  bottom: 6%;
  left: 50%;
  background: white;
  opacity: 0;
  transform: translateX(-50%);
  transition: opacity ease-in-out 0.2s;
  box-shadow: 0 10px 20px 0 rgba(16, 36, 94, 0.2);
  border-radius: 4px;
}
@media (max-width: 1199.98px) {
  .Example__container__document .page-controls {
    bottom: 15%;
  }
}
.Example__container__document .page-controls span {
  font: inherit;
  font-size: 0.8em;
  padding: 0 0.5em;
}
.Example__container__document .page-controls button {
  width: 35px;
  height: 35px;
  background: white;
  border: 0;
  font: inherit;
  font-size: 0.8em;
  border-radius: 4px;
}
.Example__container__document .page-controls button:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.Example__container__document .page-controls button:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/learn_practice/revision_materials/_pdf.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;AACJ;;AAGI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;AAAR;AAEQ;EACI,eAAA;EACA,YAAA;AAAZ;AAOgB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AALpB;AAQgB;EACI,2BAAA;EACA,kBAAA;EACA,gBAAA;AANpB;AASwB;EADJ;IAEQ,uBAAA;IACA,uBAAA;EAN1B;AACF;AAQwB;EANJ;IAOQ,uBAAA;IACA,uBAAA;EAL1B;AACF;AAQwB;EACI,eAAA;EACA,uBAAA;AAN5B;AAWgB;EACI,aAAA;EACA,cAAA;AATpB;AAaY;EACI,UAAA;AAXhB;AAcY;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;EACA,2BAAA;EACA,oCAAA;EACA,+CAAA;EACA,kBAAA;AAZhB;AAcgB;EAXJ;IAYQ,WAAA;EAXlB;AACF;AAagB;EACI,aAAA;EACA,gBAAA;EACA,gBAAA;AAXpB;AAcgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AAZpB;AAcoB;EACI,0BAAA;EACA,6BAAA;AAZxB;AAeoB;EACI,yBAAA;EACA,4BAAA;AAbxB","sourcesContent":[".modal-open .modal {\n    padding-right: 0px !important;\n}\n\n.Example {\n    &__container {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        margin: 10px 0;\n        padding: 10px;\n\n        &__load {\n            margin-top: 1em;\n            color: white;\n        }\n\n        &__document {\n            // margin: 1em 0;\n\n            .react-pdf {\n                &__Document {\n                    display: flex;\n                    flex-direction: column;\n                    align-items: center;\n                }\n\n                &__Page {\n                    max-width: calc(100% - 2em);\n                    border-radius: 8px;\n                    overflow: hidden;\n\n                    &__svg {\n                        @media (max-width:1199.98px) {\n                            width: 600px !important;\n                            height: auto !important;\n                        }\n\n                        @media (max-width:767.98px) {\n                            width: 400px !important;\n                            height: auto !important;\n                        }\n                       \n\n                        svg {\n                            max-width: 100%;\n                            height: auto !important;\n                        }\n                    }\n                }\n\n                &__message {\n                    padding: 20px;\n                    color: #ff9900;\n                }\n            }\n\n            &:hover .page-controls {\n                opacity: 1;\n            }\n\n            .page-controls {\n                position: absolute;\n                bottom: 6%;\n                left: 50%;\n                background: white;\n                opacity: 0;\n                transform: translateX(-50%);\n                transition: opacity ease-in-out 0.2s;\n                box-shadow: 0 10px 20px 0 rgba(16, 36, 94, 0.2);\n                border-radius: 4px;\n\n                @media (max-width:1199.98px) {\n                    bottom: 15%;\n                }\n\n                span {\n                    font: inherit;\n                    font-size: 0.8em;\n                    padding: 0 0.5em;\n                }\n\n                button {\n                    width: 35px;\n                    height: 35px;\n                    background: white;\n                    border: 0;\n                    font: inherit;\n                    font-size: 0.8em;\n                    border-radius: 4px;\n\n                    &:first-child {\n                        border-top-right-radius: 0;\n                        border-bottom-right-radius: 0;\n                    }\n\n                    &:last-child {\n                        border-top-left-radius: 0;\n                        border-bottom-left-radius: 0;\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
